import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetBanks, GetBankById, AddBank, UpdateBank, DeleteBank } from '../services/backend';
import { NotifyError } from '../utils/functions';

const BANKS_KEY = 'banks';

export function useGetBanks(params = {}) {
    return useQuery([BANKS_KEY, params], () => GetBanks(params), {
        staleTime: 0, // Always refetch on mount to ensure fresh data for modals
        select: (data) => data?.data?.banks || [],
        onError: (error) => {
            NotifyError('Failed to fetch banks', error);
            console.error('Error fetching banks:', error);
        },
    });
}

export function useGetBankById(bankId) {
    return useQuery([BANKS_KEY, bankId], () => GetBankById(bankId), {
        enabled: !!bankId,
        select: (data) => data?.data?.bank,
    });
}

export function useAddBank() {
    const queryClient = useQueryClient();
    return useMutation(AddBank, {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [BANKS_KEY], refetchActive: true, refetchInactive: true });
        }
    });
}

export function useUpdateBank() {
    const queryClient = useQueryClient();
    return useMutation(({ bankId, data }) => UpdateBank(bankId, data), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [BANKS_KEY], refetchActive: true, refetchInactive: true });
        }
    });
}

export function useDeleteBank() {
    const queryClient = useQueryClient();
    return useMutation(DeleteBank, {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [BANKS_KEY], refetchActive: true, refetchInactive: true });
        }
    });
}
